import React, { Component } from 'react';

export class EmpDirTree extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }

    render() {
        return (
            <body>
                <h1></h1>
            </body>
        );
    }
}